import { h } from "preact";
import Router, { RoutableProps } from "preact-router";
import { baseUrl, route } from "../../App";
import { MezosSITFlash } from "./mezos-sit-flash";
import { MezosSITOrder } from "./mezos-sit-order";
import { MezosSITSerialNumber } from "./mezos-sit-serial-number";
import "./styles.scss";
import { MezosSITReprint } from "./mezos-sit-reprint";

function MezosSITHome(props: RoutableProps) {
    return <div class="orion-sit-page">
        <h1 style="text-align: center; font-size: 30px; margin-top: 10px;">Wybierz akcje</h1>
        <div class="paper action-list">
            <div class="product-list" style="margin-top: 10px;">
                <div class="action-button" onClick={() => route("/mezos-sit/flash")}>
                    <span class="icon">developer_board</span>
                    <div class="action">Zaprogramuj pilot</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/mezos-sit/serial-number")}>
                    <span class="icon">confirmation_number</span>
                    <div class="action">Wygeneruj numery seryjne</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/mezos-sit/reprint")}>
                    <span class="icon">view_agenda</span>
                    <div class="action">Wydrukuj naklejkę dla istniejącego numeru</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/mezos-sit/order")}>
                    <span class="icon">post_add</span>
                    <div class="action">Stwórz zestawienie</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/order")}>
                    <span class="icon">list_alt</span>
                    <div class="action">Pokaż zestawienia</div>
                    <span class="icon">chevron_right</span>
                </div>
            </div>
        </div>
    </div>;
}

export function MezosSIT(props: RoutableProps) {
    return <Router>
        <MezosSITHome path={`${baseUrl}/mezos-sit`}/>
        <MezosSITSerialNumber path={`${baseUrl}/mezos-sit/serial-number`}/>
        <MezosSITReprint path={`${baseUrl}/mezos-sit/reprint`}/>
        <MezosSITOrder path={`${baseUrl}/mezos-sit/order`}/>
        <MezosSITFlash path={`${baseUrl}/mezos-sit/flash`}/>
    </Router>
}
